/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Circle.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Circle: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10" ref={ref} {...props}>
    <rect width="10" height="10" fill={color} rx="5" />
  </svg>
);
Circle.displayName = "Circle";
